import React, { useContext, useState, useEffect } from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { LanguageContext } from '../Language/LanguageContext'
import { Loading } from '../Library'
import { listPackages, listFeature, listPackageFeatureList, addFeatureToPackage, removeFeatureFromPackage, removePackage } from '../Network/Administration'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCubes } from '@fortawesome/free-solid-svg-icons'
import FeatureItem from './FeatureItem'
import "./Package.css"
import { AlertModalContext } from '../Library/AlertModalContext'

function Package() {
    const alertModal = useContext(AlertModalContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration
    const history = useHistory()
    const [isLoading, setLoading] = useState(false)
    const [packagesList, setPackageList] = useState([])
    const [featureList, setFeatureList] = useState([])

    const [selectPackage, setSelectPackage] = useState(null)
    const [selectFeatureList, setSelectFeatureList] = useState([])

    const fetchData = () =>{
        setLoading(true)
        listPackages(
            (data)=>{ 
                setPackageList(data) 
                setLoading(false)
            },
            (error)=>{ 
                setLoading(false)
            }
        )

        listFeature(
            (data)=>{ setFeatureList(data) },
            (error)=>{  }
        )
    }

    const fetchselectFeatureList = (packageId) =>{
        listPackageFeatureList(packageId,
            (data)=>{ 
                setSelectFeatureList(data) 
            },
            (error)=>{  })
    }

    const addFeature = (featureId, packageId) =>{
        console.log('FeatureId : '+ featureId);
        console.log('PackageId : '+ packageId);
        addFeatureToPackage(featureId, packageId,
            ()=>{ 
                fetchselectFeatureList(selectPackage?.id) 
                fetchData()
            },
            ()=>{  })
    }

    const removeFeature = (featureId, packageId) =>{
        removeFeatureFromPackage(featureId, packageId,
            ()=>{ 
                fetchselectFeatureList(selectPackage?.id) 
                fetchData()
            },
            ()=>{  })
    }

    const removePackageFromList = () =>{
        alertModal.setTitle(lang.delete_package)
        alertModal.setDescription(lang.sure_to_delete_package)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    alertModal.setIsShow(false)
                    setLoading(true)
                    removePackage(selectPackage?.id,
                        ()=>{ 
                            setSelectPackage(null)
                            setSelectFeatureList([]) 
                            setLoading(false)
                            fetchData()
                        },
                        ()=>{ setLoading(false) })
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
        // if(window.confirm(lang.sure_to_delete_package)){
        //     setLoading(true)
        //     removePackage(selectPackage?.id,
        //         ()=>{ 
        //             setSelectPackage(null)
        //             setSelectFeatureList([]) 
        //             setLoading(false)
        //             fetchData()
        //         },
        //         ()=>{ setLoading(false) })
        // }
    }

    useEffect(()=>{
        fetchData()
    },[])

    return (
        <div id="package">
            { isLoading ? <Loading/>: null }
            <div className="top-container">
                <Button onClick={()=>history.push("/package/create")}>
                    {lang.create_package}
                </Button>
            </div>
            <Row>
                <Col lg={6}>
                    <div className="package-container" style={{ marginBottom: 10 }}>
                        { packagesList.map((item, key)=> 
                            <PackageItem
                            key={key}
                            title={item.packageName}
                            detail={item.packageDetail}
                            count={item.count}
                            isSelected={selectPackage?.id === item.id ? true:false}
                            onClick={()=>{
                                setSelectPackage(item)
                                fetchselectFeatureList(item.id)
                            }}
                            />
                        )}
                    </div>
                </Col>
                <Col lg={6}>
                    <div className="package-container">
                        { selectPackage !== null ?
                        <>
                        <div className="detail-section">
                            <div className="title">{selectPackage?.packageName}</div>
                            <div className="detail">{selectPackage?.packageDetail}</div>
                            <div className="button-container">
                                <Button 
                                style={{ marginRight: 10 }}
                                onClick={()=>history.push("/package/edit/"+selectPackage?.id)}
                                >
                                    {lang.edit_package}
                                </Button>
                                <Button 
                                variant="danger"
                                onClick={()=>removePackageFromList()}>
                                    {lang.delete_package}
                                </Button>
                            </div>
                            <div className="select-feature-desc">{lang.select_feature}</div>
                        </div>
                        <div>
                            { featureList.map((item, key) =>
                                <FeatureItem
                                key={key}
                                title={item.featureName}
                                detail={item.featureDetail}
                                identifier={item.identifier}
                                isEnable={ selectFeatureList.some(el => el.featureId === item.id) ? true:false }
                                onToggle={()=>{
                                    if(!selectFeatureList.some(el => el.featureId === item.id)){
                                        addFeature(item.id, selectPackage.id)
                                    }else{
                                        removeFeature(item.id, selectPackage.id)
                                    }
                                }}
                                />
                            )}
                        </div>
                        </>
                        : 
                        <div className="not-select">
                            <div>
                                <div className="icon">
                                    <FontAwesomeIcon icon={faCubes}/>
                                </div>
                                <div>{lang.please_select_package}</div>
                            </div>
                        </div>
                        }
                    </div>
                </Col>
            </Row>
        </div>
    )
}

function PackageItem({ title, detail, onClick, isSelected, count }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration

    return(
        <div 
        className={ isSelected ? "package-item package-item-active": "package-item" }
        role="button"
        tabIndex="0"
        aria-pressed="false"
        onKeyDown={(e)=>{
            if(e.key === "Enter"){
                onClick()
            }
        }}
        onClick={onClick}>
            <div className="icon">
                <FontAwesomeIcon icon={faCubes}/>
            </div>
            <div style={{ flex: 1 }}>
                <div className="title">{title}</div>
                <div className="detail"
                style={{ 
                    color: isSelected ? 'white': 'gray' ,
                    maxHeight: 47
                }}>
                    <div>{detail}</div>
                </div>
                <div className="detail"
                style={{ color: isSelected ? 'white': 'gray' }}>
                    <b>{count}</b>
                    {" " + lang.count_feature}
                </div>
            </div>
        </div>
    )
}

export default Package
